var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMichalaPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "michala_aniola"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "127.75 26.72 104.53 48.84 105.37 49.28 105.37 50.29 107.86 51.11 107.86 101.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "107.73 54.01 104.89 54.01 89.94 59.99 123.71 27.1",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.15 100.38 91.81 99.88 91.81 61.51 90.15 60.18",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "127.86 64.91 113.4 73.04 112.22 72.28 127.24 64.34 127.24 63.77 127.86 63.77",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.92,
    y: 88.6,
    width: 1.45,
    height: 10.4,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.06,
    y: 76.44,
    width: 1.18,
    height: 11.28,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "114.58 72.41 114.58 76.12 116.79 76.12 116.79 71.34",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.51,
    y1: 88.1,
    x2: 114.64,
    y2: 88.1,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.68,
    y1: 96.29,
    x2: 115.68,
    y2: 90.87,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115.68,
    y1: 85.95,
    x2: 115.68,
    y2: 79.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "100.87 62.01 99.49 62.44 98.64 61.57 97.83 62.95 97 63.21",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.65,
    y1: 76.44,
    x2: 101.08,
    y2: 75.43,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "97.41 63.08 97.41 77.64 100.53 77.07 100.53 62.26",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.81,
    y1: 61.51,
    x2: 107.52,
    y2: 55.71,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.82 53.44 104.82 55.14 106.41 56.78 106.41 101.9",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "127.75 26.72 151.47 48.84 150.63 49.28 150.63 50.29 148.14 51.11 148.14 101.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "148.27 54.01 151.11 54.01 166.06 59.99 131.59 26.53",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "165.85 100.38 164.19 99.88 164.19 61.51 165.85 60.18",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "128.14 63.77 128.76 63.77 128.76 64.34 143.78 72.28 142.6 73.04 128.14 64.91",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.63,
    y: 88.6,
    width: 1.45,
    height: 10.4,
    transform: "translate(280.7 187.6) rotate(-180)",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.76,
    y: 76.44,
    width: 1.18,
    height: 11.28,
    transform: "translate(280.7 164.16) rotate(-180)",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.42 72.41 141.42 76.12 139.21 76.12 139.21 71.34",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.49,
    y1: 88.1,
    x2: 141.36,
    y2: 88.1,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.32,
    y1: 96.29,
    x2: 140.32,
    y2: 90.87,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140.32,
    y1: 85.95,
    x2: 140.32,
    y2: 79.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "155.13 62.01 156.51 62.44 157.36 61.57 158.17 62.95 159 63.21",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159.35,
    y1: 76.44,
    x2: 154.92,
    y2: 75.43,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "158.59 63.08 158.59 77.64 155.47 77.07 155.47 62.26",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.19,
    y1: 61.51,
    x2: 148.48,
    y2: 55.71,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "151.18 53.44 151.18 55.14 149.59 56.78 149.59 101.9",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.53,
    y1: 48.9,
    x2: 151.47,
    y2: 48.9,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117.04,
    y1: 71.97,
    x2: 139.03,
    y2: 71.97,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.45,
    y: 99.19,
    width: 27.16,
    height: 1.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.18,
    y: 100.45,
    width: 31.69,
    height: 1.32,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.84,
    y: 101.71,
    width: 38.37,
    height: 1.45,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.39,
    y: 103.16,
    width: 43.29,
    height: 1.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.54,
    y: 104.48,
    width: 52.99,
    height: 1.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.46,
    y: 105.74,
    width: 57.15,
    height: 1.32,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,71.84c0-4.37,7.56-4.37,7.56,0",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.67,71.84c0-2.35,4.54-2.35,4.54,0",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.87,
    y1: 69.95,
    x2: 127.87,
    y2: 65.03,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.24,
    y1: 70.45,
    x2: 122.27,
    y2: 68.31,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.68,
    y1: 70.33,
    x2: 125.23,
    y2: 68.44,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.24,
    y1: 70.01,
    x2: 126.61,
    y2: 68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.92,
    y1: 70.89,
    x2: 123.15,
    y2: 69.95,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.67,
    y1: 71.4,
    x2: 122.58,
    y2: 70.96,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.64,
    y1: 70.45,
    x2: 133.61,
    y2: 68.31,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.2,
    y1: 70.33,
    x2: 130.65,
    y2: 68.44,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.63,
    y1: 70.01,
    x2: 129.26,
    y2: 68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.95,
    y1: 70.89,
    x2: 132.73,
    y2: 69.95,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130.21,
    y1: 71.4,
    x2: 133.29,
    y2: 70.96,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.49,
    y: 74.61,
    width: 16.7,
    height: 24.07,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.22
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.81,
    y1: 74.61,
    x2: 127.81,
    y2: 98.43,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.99,
    y1: 87.97,
    x2: 125.79,
    y2: 89.23,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.82,
    y1: 87.97,
    x2: 130.02,
    y2: 89.23,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.25,28.9c-2.2-1.87-1.67-3.72.56-5.56.84-.69,1.4-1.65,1.58-2.71",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.21,28.9c2.2-1.87,1.67-3.72-.56-5.56-.82-.68-1.38-1.61-1.57-2.65",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.75,
    cy: 19.54,
    r: 1.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114.52,
    y1: 75.24,
    x2: 107.77,
    y2: 76.38,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.55,
    y1: 75.24,
    x2: 148.29,
    y2: 76.38,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.46,
    y1: 64.72,
    x2: 126.55,
    y2: 64.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129.76,
    y1: 64.72,
    x2: 132.85,
    y2: 64.72,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.54 66.36 132.54 52.21 123.84 52.21 123.84 65.94",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.73,
    y: 53.22,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.73,
    y: 55.81,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.73,
    y: 58.39,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.73,
    y: 60.98,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 53.22,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 55.81,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 58.39,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 60.98,
    width: 2.02,
    height: 1.94,
    fill: "#e77500",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "123.21 50.88 126.3 50.88 128.19 50.04 130.27 50.88 133.23 50.88",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.84,
    y1: 52.21,
    x2: 123.84,
    y2: 51.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.54,
    y1: 52.21,
    x2: 132.54,
    y2: 50.88,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.75,
    y1: 18.41,
    x2: 127.75,
    y2: 11.51,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.98,
    y1: 12.83,
    x2: 129.45,
    y2: 12.83,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125.73,
    y1: 13.87,
    x2: 129.7,
    y2: 13.87,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.3,
    y1: 16.04,
    x2: 129.13,
    y2: 17.74,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "114.77 91.18 97.47 98.84 96.62 101.01",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.61,
    y1: 106.87,
    x2: 98.61,
    y2: 98.56,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.7,
    y1: 100.82,
    x2: 114.3,
    y2: 93.64,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.7,
    y1: 103.75,
    x2: 114.01,
    y2: 96.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "141.23 91.18 158.53 98.84 159.38 101.01",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.39,
    y1: 106.87,
    x2: 157.39,
    y2: 98.56,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.3,
    y1: 100.82,
    x2: 141.7,
    y2: 93.64,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157.3,
    y1: 103.75,
    x2: 141.99,
    y2: 96.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.25,13.93c.34,1.39.97,2.8,1.86,4.23.44.72,1.04,1.32,1.73,1.81,3.26,2.3,4.43,4.9,1.33,8.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.55,13.93c-.34,1.39-.97,2.8-1.86,4.23-.44.72-1.04,1.32-1.73,1.81-3.26,2.3-4.43,4.9-1.33,8.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.75,
    cy: 13.11,
    r: 0.82,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127.75,
    y1: 12.29,
    x2: 127.75,
    y2: 1.2,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.8,
    y1: 2.4,
    x2: 128.82,
    y2: 2.4,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.91,
    y1: 4.54,
    x2: 130.46,
    y2: 4.54,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.11,
    y1: 5.99,
    x2: 129.58,
    y2: 8.14,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.23
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMichalaPop);
export default __webpack_public_path__ + "static/media/michala_pop.63cca49027838f3bc48f4e8f816f73ab.svg";
export { ForwardRef as ReactComponent };